import { createStore } from 'vuex';
import type { RootState } from '@/store/rootState';
import { userModule } from '@/store/userModule';

export type { RootState } from '@/store/rootState';

export default createStore<RootState>({
    state: () => ({
        isAuth: false,
    }),
    modules: {
        user: userModule,
    },
});
